import React, { useState } from 'react';
import {
  Button,
  Container,
  FormControl,
  InputLabel,
  Box,
  Modal,
  Tooltip,
  MenuItem,
  Select,
  AppBar,
  Toolbar,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import LoadingBar from 'react-top-loading-bar';
import { useNavigate } from 'react-router-dom';

const EditFormModules = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [moduleName, setModuleName] = useState('User Management');
  const [moduleIcon, setModuleIcon] = useState('user');
  const [moduleSequence, setModuleSequence] = useState('1');
  const [moduleDescription, setModuleDescription] = useState('Manage user roles and permissions');
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);

  const navigate = useNavigate();

  // Static list of icons for the dropdown
  const iconOptions = [
    { value: 'dashboard', label: 'Dashboard' },
    { value: 'settings', label: 'Settings' },
    { value: 'report', label: 'Report' },
    { value: 'user', label: 'User' },
    { value: 'notification', label: 'Notification' },
  ];

  const handleUpdate = (e) => {
    e.preventDefault();
    // Simulate API call
    setLoadingBarProgress(30);
    setTimeout(() => {
      setLoadingBarProgress(100);
      setShowSuccessModal(true);
    }, 1000);
  };

  const handleCancel = () => {
   navigate(-1)
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '50vh',
      }}
    >
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Edit Form Module
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <LoadingBar progress={loadingBarProgress} color="rgb(152, 106, 182)" height={5} />
        <div>
          <TextField
            label="Module Name"
            variant="outlined"
            fullWidth
            value={moduleName}
            onChange={(e) => setModuleName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel htmlFor="moduleIcon">Module Icon</InputLabel>
            <Select
              id="moduleIcon"
              value={moduleIcon}
              label="Module Icon"
              onChange={(e) => setModuleIcon(e.target.value)}
            >
              {iconOptions.map((icon) => (
                <MenuItem key={icon.value} value={icon.value}>
                  {icon.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Module Sequence"
            variant="outlined"
            fullWidth
            type="number"
            value={moduleSequence}
            onChange={(e) => setModuleSequence(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Module Description"
            variant="outlined"
            fullWidth
            multiline
            rows={4}
            value={moduleDescription}
            onChange={(e) => setModuleDescription(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip
            title={
              !moduleName
                ? "Enter Module Name"
                : !moduleIcon
                ? "Select Module Icon"
                : !moduleSequence
                ? "Enter Module Sequence"
                : !moduleDescription
                ? "Enter Module Description"
                : ""
            }
            arrow
          >
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpdate}
                sx={{ mr: 2 }}
                disabled={!moduleName || !moduleIcon || !moduleSequence || !moduleDescription}
              >
                UPDATE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Module Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Module Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // Go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditFormModules;
